import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // 1. Added this import
// Pismo zo samotnej aplikacie, nie z Googlu -- viac v public/index.html.
// Vahy sedia s tym, co pouziva styles/_variables.scss ($font-weight-*).
//
// VEDOME sa importuju PLNE subory, nie podmnoziny `latin-*` a `latin-ext-*`.
// Tie totiz nedeklaruju `unicode-range`, takze by vznikli dve pravidla
// @font-face s rovnakou rodinou aj vahou a to neskorsie by prebilo to prve --
// bezny text by ostal bez pisma. Plne subory `unicode-range` maju, takze
// prehliadac aj tak stiahne len tie podmnoziny, ktore na stranke naozaj su
// (u nas latin a latin-ext). Do buildu ide viac suborov, k navstevnikovi nie.
import "@fontsource/nunito/400.css";
import "@fontsource/nunito/500.css";
import "@fontsource/nunito/600.css";
import "@fontsource/nunito/700.css";
import "./styles/theme.scss";
import "./index.css";
import "./features/axiosInterceptor";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./features/errorBoundary"; // 2. Added this import
import { getTenantBasename } from "./features/tenantResolver";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* basename = prevadzka z URL ("/veteran", "/sprava", pri vlastnej domene "").
        Odvodeny VZDY z URL, nikdy z konfiguracie -- nezhoda by skoncila bielou
        strankou bez chyby. React Router potom prefixuje kazdy <Link> aj navigate(). */}
    <BrowserRouter basename={getTenantBasename()}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();
